import { SvgIcon } from '@mui/material';
const Folder = props => {
  return <SvgIcon viewBox="0 0 22 17" fill="none" {...props}>
      <path d="M21.376 9.00273L17.876 15.7527C17.6792 16.1359 17.2745 16.375 16.8005 16.375H0.5L4.84583 7.99727C5.04271 7.61406 5.4474 7.375 5.88854 7.375H20.3333C21.1974 7.375 21.7625 8.25391 21.376 9.00273Z" fill="currentColor" />
      <path opacity="0.4" d="M18 4.5625V7.375H5.88854C5.4474 7.375 5.04271 7.61406 4.84583 7.99727L0.5 16.375V2.3125C0.5 1.38051 1.28349 0.625 2.25 0.625H8.08333L10.4167 2.875H16.25C17.2161 2.875 18 3.63086 18 4.5625Z" fill="currentColor" />
    </SvgIcon>;
};
export default Folder;